import { render } from "./UserWallet.vue?vue&type=template&id=01a479ae&scoped=true&ts=true"
import script from "./UserWallet.vue?vue&type=script&lang=ts"
export * from "./UserWallet.vue?vue&type=script&lang=ts"

import "./UserWallet.vue?vue&type=style&index=0&id=01a479ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a479ae"]])

export default __exports__